var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PaginationWells',{staticClass:"pagination-row--top"}),_vm._t("default"),_c('PaginationWells',{staticClass:"pagination-row--bottom"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }